//
//
//
//
//
//

import gameCont from '../game/index.vue'
export default {
  name: "sports",
  components: {gameCont},
  data() {
    return {
      gameTypeCode: '3',
    }
  }
};



// WEBPACK FOOTER //
// ./src/pages/build922/views/home/pages-3.vue